<template>
    <v-simple-table class="campaign-table-container">
        <template v-slot:default>
            <tbody>
                <tr v-for="row in rows.filter(rowToFilter => rowToFilter.renderCondition ?? true)" :key="row.header">
                    <td class="td-header">{{ row.header }}</td>
                    <td v-if="!row.type">{{ row.value }}</td>
                    <td v-else-if="row.type === 'slot'">
                        <slot :name="row.slot" />
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
    export default {
        props: {
            rows: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped>
.campaign-table-container {
    flex-grow: 1;
}

.td-header {
    font-weight: bold;
}
</style>
